// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SignIn from "./pages/SignIn";
import Nav from "./conponents/layout/Nav";
import routes from "./utils/routes";
import useWebSocket from "./utils/useWebSocket";
import Header from "./conponents/layout/Header";

import { useDispatch, useSelector } from "react-redux";
import {
  auth,
  selectAuth,
  selectUser,
  selectAuthLoading,
} from "./store/authSlice";
import { ToastContainer } from "react-toastify";
import { Bounce } from "react-toastify";
export default function App() {
  const dispatch = useDispatch();
  const isAuth = useSelector(selectAuth);
  const userData = useSelector(selectUser);
  const loadingAuth = useSelector(selectAuthLoading);

  useWebSocket(isAuth);

  // 初始化驗證
  useEffect(() => {
    dispatch(auth());
  }, [dispatch]);

  return (
    <>
      {loadingAuth ? (
        <div className="flex items-center justify-center min-h-screen text-white">
          檢查登入中...
        </div>
      ) : !isAuth ? (
        <SignIn />
      ) : (
        <Router>
          <div className="flex flex-col lg:flex-row overflow-auto h-screen bg-[url('../public/assets/images/ems-bg.png')] bg-cover bg-no-repeat bg-center text-white">
            <Nav />
            <div className="flex flex-col w-full">
              <Header userData={userData} />
              <main className="w-full p-6 overflow-auto flex flex-col gap-2 max-w-[100vw] lg:max-w-[calc(100vw-258px)]">
                <Routes>
                  {routes.map(({ path, element }) => (
                    <Route key={path} path={path} element={element} />
                  ))}
                </Routes>
              </main>
            </div>
          </div>
        </Router>
      )}

      {/* ToastContainer 放在最外層，始終存在 */}
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        transition={Bounce}
      />
    </>
  );
}
